export const fancyRecipes: Record<string, string[]> = {
  "shipcat": [
    "sphynx",
    "orangesoda",
    "luckystripe",
    "crazy"
  ],
  "ducat": [
    "cymric",
    "tongue"
  ],
  "dracula": [
    "laperm",
    "spock",
    "strawberry",
    "WE00"
  ],
  "mistletoe": [
    "oldlace",
    "crazy",
    "gerbil"
  ],
  "santaclaws": [
    "cloudwhite",
    "scarlet",
    "beard",
    "WE12"
  ],
  "phuziqaat": [
    "chartreux",
    "spock",
    "alien",
    "pouty"
  ],
  "stitches": [
    "hintomint",
    "seafoam",
    "swampgreen",
    "saycheese"
  ],
  "negato": [
    "onyx",
    "henna",
    "wolfgrey",
    "slyboots"
  ],
  "momo-chan": [
    "onyx",
    "henna",
    "bloodred",
    "wolfgrey",
    "sass"
  ],
  "earnie": [
    "birman",
    "orangesoda",
    "hotrod",
    "grim"
  ],
  "misterpurrfect": [
    "chocolate",
    "baddate",
    "strawberry",
    "wuvme"
  ],
  "yuricatsuki": [
    "cymric",
    "tiger",
    "neckbeard",
    "elk"
  ],
  "tabby": [
    "ragamuffin",
    "morningglory",
    "otaku",
    "cheeky"
  ],
  "汪星爷": [
    "tigerpunk",
    "periwinkle",
    "barkbrown",
    "sweetmeloncakes",
    "yokel"
  ],
  "咚咚锵": [
    "manx",
    "royalblue",
    "googly",
    "starstruck"
  ],
  "红包喵": [
    "harbourfog",
    "calicool",
    "swampgreen",
    "sapphire",
    "beard"
  ],
  "pussforprogress": [
    "himalayan",
    "peach",
    "safetyvest",
    "gerbil"
  ],
  "berry": [
    "dragonfruit",
    "thunderstruck",
    "emeraldgreen",
    "apricot",
    "simple"
  ],
  "vernon": [
    "amur",
    "fabulous",
    "cottoncandy",
    "springcrocus",
    "belleblue",
    "soserious"
  ],
  "flutterbee": [
    "cloudwhite",
    "jaguar",
    "lemonade",
    "azaleablush",
    "WE14"
  ],
  "docpurr": [
    "persian",
    "spock",
    "raisedbrow",
    "violet",
    "tongue"
  ],
  "chatplongeur": [
    "aquamarine",
    "skyblue",
    "seafoam"
  ],
  "swish": [
    "norwegianforest",
    "luckystripe",
    "thicccbrowz",
    "orangesoda"
  ],
  "schrödingerscat": [
    "forgetmenot",
    "tinybox",
    "PU20",
    "SE25"
  ],
  "page": [
    "rascal",
    "peach",
    "wasntme"
  ],
  "furrmingo": [
    "bobtail",
    "egyptiankohl",
    "flamingo",
    "whixtensions"
  ],
  "kittypride": [
    "fabulous",
    "cinderella",
    "garnet"
  ],
  "raspoutine": [
    "buzzed",
    "nachocheez",
    "sandalwood",
    "belch"
  ],
  "boot": [
    "ganado",
    "wiley",
    "cerulian",
    "rollercoaster"
  ],
  "lulu": [
    "cyan",
    "verdigris",
    "turtleback",
    "salty"
  ],
  "catbury": [
    "ragdoll",
    "crazy",
    "chocolate",
    "mintmacaron",
    "yokel",
    "WE02"
  ],
  "purrspero": [
    "dippedcone",
    "googly",
    "royalpurple",
    "beard"
  ],
  "squiddlesworth": [
    "sphynx",
    "redvelvet",
    "patrickstarfish",
    "dragontail"
  ],
  "purrity": [
    "selkirk",
    "chronic",
    "cloudwhite",
    "cheeky"
  ],
  "atlas": [
    "highlander",
    "kittencream",
    "swarley",
    "topoftheworld"
  ],
  "meowstro": [
    "onyx",
    "wowza",
    "eclipse"
  ],
  "pawzilla": [
    "jaguar",
    "universe",
    "atlantis",
    "littlefoot"
  ],
  "sheilapurren": [
    "mauveover",
    "icy",
    "wingtips",
    "fangtastic"
  ],
  "dukecat": [
    "cymric",
    "periwinkle",
    "simple",
    "tongue"
  ],
  "pickles": [
    "lynx",
    "martian",
    "highsociety",
    "emeraldgreen"
  ],
  "dreggo": [
    "siberian",
    "bananacream",
    "SE03"
  ],
  "dracojunior": [
    "lynx",
    "verdigris",
    "dragontail",
    "SE03"
  ],
  "draco": [
    "toyger",
    "martian",
    "peppermint",
    "dragonwings",
    "SE03"
  ],
  "pawrula": [
    "fox",
    "camo",
    "butterscotch"
  ],
  "genedough": [
    "hotcocoa",
    "mittens",
    "frosting"
  ],
  "tallythepurrocious": [
    "selkirk",
    "arcreactor",
    "koala",
    "sully"
  ],
  "squib": [
    "oldlace",
    "razzledazzle",
    "buzzed",
    "rollercoaster"
  ],
  "misspurrfect": [
    "allyouneed",
    "butterscotch",
    "asif",
    "satiated",
    "flapflap"
  ],
  "pizzazz": [
    "mekong",
    "spangled",
    "scarlet",
    "wonky"
  ],
  "al": [
    "munchkin",
    "brownies",
    "cashewmilk",
    "moue"
  ],
  "ande": [
    "munchkin",
    "cashewmilk",
    "moue",
    "PU30",
    "WE10"
  ],
  "glasswalker": [
    "cloudwhite",
    "henna",
    "pearl",
    "firedup"
  ],
  "clover": [
    "shamrock",
    "emeraldgreen",
    "roadtogold",
    "PU27"
  ],
  "glitter": [
    "hyacinth",
    "rorschach",
    "unicorn",
    "juju"
  ],
  "furbeard": [
    "inflatablepool",
    "hanauma",
    "neckbeard"
  ],
  "krakitten": [
    "splat",
    "cobalt",
    "ducky",
    "salty"
  ],
  "curdlin": [
    "dippedcone",
    "nachocheez",
    "missmuffet",
    "saycheese"
  ],
  "whisper": [
    "onyx",
    "henna",
    "wolfgrey",
    "sully",
    "candyshoppe"
  ],
  "kitijira": [
    "mainecoon",
    "moonrise",
    "atlantis",
    "universe",
    "dragontail"
  ],
  "magmeow": [
    "liger",
    "moonrise",
    "redvelvet",
    "dragontail"
  ],
  "catamari": [
    "moonrise",
    "cobalt",
    "ducky",
    "salty"
  ],
  "catyrax": [
    "lykoi",
    "henna",
    "bornwithit",
    "onyx",
    "wolfgrey",
    "fallspice",
    "SE28"
  ],
  "poisonorchid": [
    "burmilla",
    "henna",
    "drama",
    "onyx",
    "wolfgrey",
    "dreamboat",
    "SE29"
  ],
  "djmeowlody": [
    "ragdoll",
    "tigerpunk",
    "oceanid",
    "happygokitty"
  ],
  "kittyformerlyknownasprince": [
    "leopard",
    "tendertears",
    "royalblue",
    "pouty"
  ],
  "robin": [
    "stunned",
    "meowgarine",
    "kittencream",
    "featherbrain"
  ],
  "pawderick": [
    "ganado",
    "rosequartz",
    "wasntme"
  ],
  "purrzival": [
    "thunderstruck",
    "rosequartz",
    "peach",
    "wasntme"
  ],
  "jack": [
    "savannah",
    "shadowgrey",
    "granitegrey",
    "jacked"
  ],
  "furmione": [
    "spangled",
    "firstblush",
    "poisonberry",
    "mallowflower"
  ],
  "skeletonne": [
    "sphynx",
    "scorpius",
    "dreamboat",
    "satiated"
  ],
  "catseye": [
    "burmilla",
    "rascal",
    "salmon",
    "flamingo"
  ],
  "gwendolion": [
    "burmilla",
    "salmon",
    "icy"
  ],
  "bartholomeow": [
    "burmilla",
    "thunderstruck",
    "salmon",
    "flamingo",
    "rosequartz",
    "wasntme"
  ],
  "shoopadoop": [
    "martian",
    "wyrm",
    "SE03"
  ],
  "puuurrot": [
    "chantilly",
    "firstblush",
    "skyblue",
    "tinybox"
  ],
  "chitten": [
    "burmilla",
    "calicool",
    "hotcocoa",
    "tongue"
  ],
  "pepito": [
    "ragdoll",
    "simple",
    "meowgarine",
    "junglebook"
  ],
  "cosmocat": [
    "leopard",
    "universe",
    "topoftheworld",
    "finalfrontier"
  ],
  "mars": [
    "hacker",
    "prairierose",
    "delite",
    "finalfrontier"
  ],
  "lilpurrfect": [
    "allyouneed",
    "garnet",
    "flapflap"
  ],
  "meuwn": [
    "razzledazzle",
    "cloudwhite",
    "springcrocus",
    "finalfrontier"
  ],
  "felis": [
    "mekong",
    "moonrise",
    "buzzed",
    "finalfrontier"
  ],
  "missmatheson": [
    "liger",
    "icicle",
    "hacker",
    "kittencream"
  ],
  "cai": [
    "pixiebob",
    "shamrock",
    "mertail",
    "hanauma"
  ],
  "potricia": [
    "onyx",
    "gold",
    "mertail",
    "roadtogold"
  ],
  "cindi": [
    "pixiebob",
    "dragonfruit",
    "prairierose",
    "missmuffet"
  ],
  "bodhi": [
    "avatar",
    "chameleon",
    "mertail",
    "majestic"
  ],
  "billie": [
    "pixiebob",
    "cornflower",
    "cerulian",
    "mintmacaron"
  ],
  "zelig": [
    "avatar",
    "glacier",
    "chameleon",
    "happygokitty"
  ],
  "vince": [
    "pixiebob",
    "bananacream",
    "daffodil",
    "ooze"
  ],
  "hunter": [
    "avatar",
    "chameleon",
    "tongue",
    "dragontail"
  ],
  "kitiovanni": [
    "manx",
    "candyshoppe",
    "firstblush",
    "springcrocus",
    "wyrm"
  ],
  "kunst": [
    "mainecoon",
    "candyshoppe",
    "royalblue"
  ],
  "janis": [
    "glacier",
    "springcrocus",
    "prism"
  ],
  "pawvril": [
    "glacier",
    "springcrocus",
    "drama"
  ],
  "steel": [
    "lykoi",
    "hintomint",
    "springcrocus",
    "prism"
  ],
  "travis": [
    "firedup",
    "wolfgrey",
    "glacier",
    "prism"
  ],
  "starchild": [
    "razzledazzle",
    "drama",
    "glacier",
    "wolfgrey",
    "prism"
  ],
  "joan": [
    "lykoi",
    "drama",
    "glacier",
    "springcrocus",
    "prism"
  ],
  "pickett": [
    "swarley",
    "lavender",
    "dune"
  ],
  "reeves": [
    "rascal",
    "swarley",
    "daemonwings",
    "dune"
  ],
  "mibbles": [
    "Kurilian",
    "impish"
  ],
  "boris": [
    "savannah",
    "safetyvest",
    "jacked"
  ],
  "dart": [
    "camo",
    "oldlace",
    "coffee",
    "dune"
  ],
  "abby": [
    "ragamuffin",
    "swarley",
    "dune"
  ],
  "catfrost": [
    "splat",
    "wiley",
    "icicle",
    "icy"
  ],
  "holly": [
    "wingtips",
    "chartreux",
    "icy"
  ],
  "dave": [
    "norwegianforest",
    "icy",
    "frozen"
  ],
  "ellie": [
    "shadowgrey",
    "flaming",
    "littlefoot",
    "walrus"
  ],
  "harriet": [
    "kurilian",
    "flamingo",
    "cheeky"
  ],
  "tarun": [
    "caffeine",
    "mintmacaron",
    "topoftheworld"
  ],
  "purrwin": [
    "koladiviya",
    "purplehaze",
    "tinybox"
  ],
  "quentin": [
    "jaguar",
    "orangesoda",
    "fabulous",
    "beard"
  ],
  "keeper": [
    "littlefoot",
    "vigilante",
    "confuzzled"
  ],
  "sweeper": [
    "littlefoot",
    "vigilante",
    "belch"
  ],
  "winger": [
    "littlefoot",
    "vigilante",
    "fangtastic"
  ],
  "striker": [
    "littlefoot",
    "vigilante",
    "soserious"
  ]
}
